import { Component, ElementRef, HostListener, input, OnDestroy, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.html',
  styleUrl: './tooltip.scss',
})
export class Tooltip implements OnDestroy {
  text = input<string>('');
  position = input<'top' | 'bottom' | 'left' | 'right'>('top');

  private tooltipEl: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    const rect: DOMRect = this.el.nativeElement.getBoundingClientRect();

    this.tooltipEl = this.renderer.createElement('span');
    this.renderer.setProperty(this.tooltipEl, 'textContent', this.text());
    this.renderer.setAttribute(this.tooltipEl, 'class',
      'fixed z-[9999] px-2 py-1 text-xs bg-secondary text-white rounded whitespace-nowrap pointer-events-none'
    );

    const style = this.tooltipEl!.style;
    switch (this.position()) {
      case 'top':
        style.bottom = `${window.innerHeight - rect.top + 8}px`;
        style.left = `${rect.left + rect.width / 2}px`;
        style.transform = 'translateX(-50%)';
        break;
      case 'bottom':
        style.top = `${rect.bottom + 8}px`;
        style.left = `${rect.left + rect.width / 2}px`;
        style.transform = 'translateX(-50%)';
        break;
      case 'left':
        style.top = `${rect.top + rect.height / 2}px`;
        style.right = `${window.innerWidth - rect.left + 8}px`;
        style.transform = 'translateY(-50%)';
        break;
      case 'right':
        style.top = `${rect.top + rect.height / 2}px`;
        style.left = `${rect.right + 8}px`;
        style.transform = 'translateY(-50%)';
        break;
    }

    this.renderer.appendChild(document.body, this.tooltipEl);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.removeTooltip();
  }

  ngOnDestroy() {
    this.removeTooltip();
  }

  private removeTooltip() {
    if (this.tooltipEl) {
      this.renderer.removeChild(document.body, this.tooltipEl);
      this.tooltipEl = null;
    }
  }
}
